import { render } from "./AppStockQty.vue?vue&type=template&id=cdc8247a"
import script from "./AppStockQty.vue?vue&type=script&lang=js"
export * from "./AppStockQty.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__